import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import FilterMenuRadioListLegacy from './_do_not_import_/FilterMenuRadioList';
import FilterMenuRadioListV2, { IFilterMenuRadioListProps } from './_do_not_import_v2_/FilterMenuRadioList';

export const FilterMenuRadioList = (props: IFilterMenuRadioListProps) => {
  const flags = useFlags<{ bookingViewV2: boolean }>();

  if (flags.bookingViewV2) {
    return <FilterMenuRadioListV2 {...props} />;
  }

  return <FilterMenuRadioListLegacy {...props} />;
};
